import React from 'react'
import Paginate from 'react-paginating'

export default function Pagination(props) {
  let {
    total,
    limit,
    current,
    pageCount = 5,
    getLinkProps = () => ({}),
    className,
    ...rest
  } = props

  total = total || 0
  limit = limit ? parseInt(limit, 10) : 20

  const currentPage = current ? parseInt(current, 10) : 1
  const min = currentPage * limit - limit + 1
  const max = Math.min(currentPage * limit, total)

  return (
    <Paginate
      total={total}
      limit={limit}
      pageCount={pageCount}
      currentPage={currentPage}
    >
      {({
        pages,
        hasNextPage,
        hasPreviousPage,
        previousPage,
        nextPage,
        totalPages,
        getPageItemProps
      }) => (
        <div
          className={[
            className,
            'leading-tight text-xs font-semibold',
          ]}
        >

          {typeof props.extraLinks === 'function' && (props.extraLinks({ hasPreviousPage, hasNextPage }))}

          <div className="flex items-center justify-center">
            {hasPreviousPage && (
              <PaginationLink
                key="prev"
                rel="prev"
                children="Prev"
                {...getLinkProps({ page: previousPage, prev: true })}
              />
            )}
            {pages.length > 1 && pages.map(page => (
              <PaginationLink
                key={page}
                children={page}
                active={currentPage === page}
                hideMobile={true}
                {...getLinkProps({ page: page, current: currentPage === page })}
              />
            ))}
            {hasNextPage && (
              <PaginationLink
                key="next"
                rel="next"
                children="Next"
                {...getLinkProps({ page: nextPage, next: true })}
              />
            )}
          </div>
          {totalPages ? (
            <div className="mt-4 text-center text-gray-600">
              Results {min} - {max} out of {total}
            </div>
          ) : null}
        </div>
      )}
    </Paginate>
  )
}

function PaginationLink({ active, className, hideMobile, ...rest }) {
  return (
    <a
      {...rest}
      className={[
        'btn px-5 py-3 mx-1',
        active ? 'bg-navy border-none text-white' : 'bg-white border border-gray-300 hover:bg-gray-200',
        hideMobile && 'hidden sm:block',
        className,
      ]}
    />
  )
}
